import React from 'react';
import PropTypes from 'prop-types';
import {  ButtonContainer, CalendarHeader, CalendarWrapper, ConfirmVisitText, StyledModal, TourButton } from './styles';
import { Modal } from 'react-bootstrap';

const TourInitiationPopup = ({ 
  showModal, 
  onTakeTour, 
  onSkipTour,
  isNewUser = true
}) => ( 
  <StyledModal show={showModal}>
    <div className="modal-content-padding">
      <CalendarHeader>
        <div className="left-content">
          <div>{isNewUser ? "Let's get you started right" : "Get more out of Woliba"}</div>
        </div>
      </CalendarHeader>
      <CalendarWrapper>
        <ConfirmVisitText>
          Want a quick tour of your dashboard to see what you can do? You can jump in now or skip it and explore on your own.
        </ConfirmVisitText>
      </CalendarWrapper>
    </div>

    <Modal.Footer style={{borderTop:'none', display:'flex', padding:'0px', justifyContent:'center'}}>
      <ButtonContainer>
        <TourButton primary onClick={onTakeTour}>
          Take the tour
        </TourButton>
        <TourButton onClick={onSkipTour}>
          Remind me later
        </TourButton>
      </ButtonContainer>
    </Modal.Footer>
  </StyledModal>
);

TourInitiationPopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onTakeTour: PropTypes.func.isRequired,
  onSkipTour: PropTypes.func.isRequired,
  isNewUser: PropTypes.bool
};

export default TourInitiationPopup;
